const locale = {
  MODAL_VERIFICATION_TITLE: 'Enter the verification code',
  MODAL_VERIFICATION_DESCRIPTION: `We’ve sent a 6-digit code to your email. Please enter it to verify your account.`,
  MODAL_VERIFICATION_BUTTON: 'Verify',
  MODAL_VERIFICATION_NOT_RECEIVED_CODE: 'Didn’t receive the code?',
  MODAL_VERIFICATION_TEXT_TIMER: 'You can resend it in',
  MODAL_VERIFICATION_RESEND_CODE: 'Resend the code',
  MODAL_VERIFICATION_FAILED_ATTEMPTS: 'Too many failed attempts',
  MODAL_VERIFICATION_TRY_AGAIN: 'Try again in',
};

export default locale;
